var _path, _path2, _path3, _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _rect9, _rect10, _rect11, _rect12, _rect13, _rect14, _rect15, _path4, _path5, _path6, _g, _path7, _g2, _rect16, _path8, _path9, _path10, _path11, _rect17, _rect18, _rect19, _rect20, _rect21, _rect22, _rect23, _rect24, _rect25, _rect26, _rect27, _rect28, _rect29, _rect30, _rect31, _path12, _path13, _path14, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
import { forwardRef } from "react";
var SvgAddDocument = function SvgAddDocument(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 70,
    viewBox: "0 0 64 70",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M36.3298 56.5091C36.3298 51.9603 40.8149 47.7665 45.357 47.7665C46.0528 47.7665 46.7277 47.5907 47.3753 47.7524C47.384 47.5538 47.3893 46.3867 47.3893 46.1863V0H8.07329L0 8.305V62.0458H37.1196C36.321 60.7768 36.3298 58.1209 36.3298 56.5091Z",
    fill: "url(#paint0_linear_4684_169134)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M35.7496 57.4719C35.7496 51.8032 40.3317 47.2079 45.984 47.2079C46.2928 47.2079 46.5963 47.2228 46.9007 47.2491V23.4504H0.977051V61.0688H36.396C35.9672 59.9184 35.7483 58.7001 35.7496 57.4719Z",
    fill: "#FCFCFC"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M46.9005 23.4504H0.488281V8.23855L7.99373 0.488525H46.9005V23.4504V23.4504Z",
    fill: "#FCFCFC"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 31.2676,
    y: 5.37402,
    width: 12.7023,
    height: 0.977099,
    fill: "#E0E0E0"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 31.2676,
    y: 8.79395,
    width: 12.7023,
    height: 0.977099,
    fill: "#E0E0E0"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 31.2676,
    y: 12.2139,
    width: 12.7023,
    height: 0.977099,
    fill: "#E0E0E0"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.5,
    x: 31.2676,
    y: 15.6335,
    width: 12.7023,
    height: 0.977099,
    fill: "#536DFE"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 31.2676,
    y: 19.0535,
    width: 12.7023,
    height: 0.977099,
    fill: "#E0E0E0"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 31.2676,
    y: 22.4734,
    width: 12.7023,
    height: 0.977099,
    fill: "#E0E0E0"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.5,
    x: 7.32812,
    y: 30.29,
    width: 12.7023,
    height: 0.977099,
    fill: "#536DFE"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 7.32812,
    y: 33.71,
    width: 12.7023,
    height: 0.977099,
    fill: "#E0E0E0"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.5,
    x: 7.32812,
    y: 32.2441,
    width: 32.7328,
    height: 0.977099,
    fill: "#69F0AE"
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.5,
    x: 7.32812,
    y: 39.5725,
    width: 12.7023,
    height: 0.977099,
    fill: "#536DFE"
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    x: 7.32812,
    y: 42.9924,
    width: 12.7023,
    height: 0.977099,
    fill: "#E0E0E0"
  })), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    x: 7.32812,
    y: 41.0381,
    width: 32.7328,
    height: 0.977099,
    fill: "#E0E0E0"
  })), _rect13 || (_rect13 = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.5,
    x: 7.32812,
    y: 48.3665,
    width: 12.7023,
    height: 0.977099,
    fill: "#536DFE"
  })), _rect14 || (_rect14 = /*#__PURE__*/React.createElement("rect", {
    x: 7.32812,
    y: 52.2749,
    width: 12.7023,
    height: 0.977099,
    fill: "#E0E0E0"
  })), _rect15 || (_rect15 = /*#__PURE__*/React.createElement("rect", {
    x: 7.32812,
    y: 50.3206,
    width: 26.8702,
    height: 0.977099,
    fill: "#E0E0E0"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M27.3593 24.9161H4.39746V4.87939L5.19229 3.90845H7.02482H27.3593V24.9161V24.9161Z",
    fill: "#536DFE"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M0.488281 8.79387H8.30507V0.488525L0.488281 8.79387V8.79387Z",
    fill: "url(#paint1_linear_4684_169134)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M0.488281 8.30532H7.81653V0.488525L0.488281 8.30532V8.30532Z",
    fill: "#F5F5F5"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "M55.206 69.8627C60.0627 69.8627 63.9999 65.9255 63.9999 61.0688C63.9999 56.2121 60.0627 52.2749 55.206 52.2749C50.3493 52.2749 46.4121 56.2121 46.4121 61.0688C46.4121 65.9255 50.3493 69.8627 55.206 69.8627Z",
    fill: "url(#paint2_linear_4684_169134)"
  }))), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M55.2057 68.8856C59.7926 68.8856 63.5111 65.2765 63.5111 60.8245C63.5111 56.3725 59.7926 52.7634 55.2057 52.7634C50.6188 52.7634 46.9004 56.3725 46.9004 60.8245C46.9004 65.2765 50.6188 68.8856 55.2057 68.8856Z",
    fill: "#3AD29F"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "M59.603 60.0861H56.1877V56.6716H54.2244V60.0861H50.8091V62.0502H54.2244V65.4655H56.1877V62.0502H59.603V60.0861V60.0861Z",
    fill: "url(#paint3_linear_4684_169134)"
  }))), _rect16 || (_rect16 = /*#__PURE__*/React.createElement("rect", {
    x: 54.229,
    y: 57.1604,
    width: 1.9542,
    height: 7.32824,
    fill: "white"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M58.8555 60.0916V61.7746H51.2977V60.0916H58.8555Z",
    fill: "white"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M45.612 60.4176C45.612 55.8687 50.0971 51.6749 54.6392 51.6749C55.3351 51.6749 56.0099 51.4992 56.6575 51.6609C56.6663 51.4622 56.6715 50.2952 56.6715 50.0948V3.90845H17.3555L9.28223 12.2134V65.9542H46.4018C45.6032 64.6852 45.612 62.0294 45.612 60.4176Z",
    fill: "url(#paint4_linear_4684_169134)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M44.5435 61.3804C44.5435 55.7117 49.1256 51.1163 54.7779 51.1163C55.0867 51.1163 55.3903 51.1312 55.6947 51.1575V27.3589H9.771V64.9772H45.1899C44.7612 63.8268 44.5422 62.6085 44.5435 61.3804V61.3804Z",
    fill: "white"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M56.1832 27.3588H9.771V12.147L17.2764 4.39697H56.1832V27.3588V27.3588Z",
    fill: "white"
  })), _rect17 || (_rect17 = /*#__PURE__*/React.createElement("rect", {
    x: 40.5498,
    y: 9.28247,
    width: 12.7023,
    height: 0.977099,
    fill: "#E0E0E0"
  })), _rect18 || (_rect18 = /*#__PURE__*/React.createElement("rect", {
    x: 40.5498,
    y: 12.7024,
    width: 12.7023,
    height: 0.977099,
    fill: "#E0E0E0"
  })), _rect19 || (_rect19 = /*#__PURE__*/React.createElement("rect", {
    x: 40.5498,
    y: 16.1221,
    width: 12.7023,
    height: 0.977099,
    fill: "#E0E0E0"
  })), _rect20 || (_rect20 = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.5,
    x: 40.5498,
    y: 19.542,
    width: 12.7023,
    height: 0.977099,
    fill: "#536DFE"
  })), _rect21 || (_rect21 = /*#__PURE__*/React.createElement("rect", {
    x: 40.5498,
    y: 22.9619,
    width: 12.7023,
    height: 0.977099,
    fill: "#E0E0E0"
  })), _rect22 || (_rect22 = /*#__PURE__*/React.createElement("rect", {
    x: 40.5498,
    y: 26.3816,
    width: 12.7023,
    height: 0.977099,
    fill: "#E0E0E0"
  })), _rect23 || (_rect23 = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.5,
    x: 16.6108,
    y: 34.1985,
    width: 12.7023,
    height: 0.977099,
    fill: "#536DFE"
  })), _rect24 || (_rect24 = /*#__PURE__*/React.createElement("rect", {
    x: 16.6108,
    y: 38.1069,
    width: 12.7023,
    height: 0.977099,
    fill: "#E0E0E0"
  })), _rect25 || (_rect25 = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.5,
    x: 16.6108,
    y: 36.1526,
    width: 32.7328,
    height: 0.977099,
    fill: "#69F0AE"
  })), _rect26 || (_rect26 = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.5,
    x: 16.6108,
    y: 43.481,
    width: 12.7023,
    height: 0.977099,
    fill: "#536DFE"
  })), _rect27 || (_rect27 = /*#__PURE__*/React.createElement("rect", {
    x: 16.6108,
    y: 46.9006,
    width: 12.7023,
    height: 0.977099,
    fill: "#E0E0E0"
  })), _rect28 || (_rect28 = /*#__PURE__*/React.createElement("rect", {
    x: 16.6108,
    y: 45.4351,
    width: 32.7328,
    height: 0.977099,
    fill: "#E0E0E0"
  })), _rect29 || (_rect29 = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.5,
    x: 16.6108,
    y: 52.2749,
    width: 12.7023,
    height: 0.977099,
    fill: "#536DFE"
  })), _rect30 || (_rect30 = /*#__PURE__*/React.createElement("rect", {
    x: 16.6108,
    y: 56.1831,
    width: 12.7023,
    height: 0.977099,
    fill: "#E0E0E0"
  })), _rect31 || (_rect31 = /*#__PURE__*/React.createElement("rect", {
    x: 16.6108,
    y: 54.229,
    width: 26.8702,
    height: 0.977099,
    fill: "#E0E0E0"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M36.641 28.8245H13.6792V8.78784L14.474 7.81689H16.3066H36.641V28.8245V28.8245Z",
    fill: "#536DFE"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M9.771 12.7023H17.5878V4.39697L9.771 12.7023V12.7023Z",
    fill: "url(#paint5_linear_4684_169134)"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M9.771 12.2138H17.0992V4.39697L9.771 12.2138V12.2138Z",
    fill: "#FCFCFC"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_4684_169134",
    x1: 47.388,
    y1: 62.0458,
    x2: 47.388,
    y2: 0,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B3B3B3",
    stopOpacity: 0.25
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#B3B3B3",
    stopOpacity: 0.1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B3B3B3",
    stopOpacity: 0.05
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_4684_169134",
    x1: 8.30551,
    y1: 8.79387,
    x2: 8.30551,
    y2: 0.488525,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B3B3B3",
    stopOpacity: 0.25
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#B3B3B3",
    stopOpacity: 0.1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B3B3B3",
    stopOpacity: 0.05
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_4684_169134",
    x1: 63.9999,
    y1: 69.8627,
    x2: 63.9999,
    y2: 52.2749,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#808080",
    stopOpacity: 0.25
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#808080",
    stopOpacity: 0.12
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#808080",
    stopOpacity: 0.1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_4684_169134",
    x1: 59.603,
    y1: 65.4655,
    x2: 59.603,
    y2: 56.6716,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#808080",
    stopOpacity: 0.25
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#808080",
    stopOpacity: 0.12
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#808080",
    stopOpacity: 0.1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_4684_169134",
    x1: 56.6702,
    y1: 65.9542,
    x2: 56.6702,
    y2: 3.90845,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B3B3B3",
    stopOpacity: 0.25
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#B3B3B3",
    stopOpacity: 0.1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B3B3B3",
    stopOpacity: 0.05
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_4684_169134",
    x1: 17.5882,
    y1: 12.7023,
    x2: 17.5882,
    y2: 4.39697,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B3B3B3",
    stopOpacity: 0.25
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#B3B3B3",
    stopOpacity: 0.1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B3B3B3",
    stopOpacity: 0.05
  })))));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgAddDocument);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "add-document.ada8e40e4836e38b619dad92d771d453.svg";